<kl-form-container
  [mode]="mode"
  [title]="title + (mode === 'edit' || mode === 'view' ? entity.code : '')"
  [pageId]="tabId ? tabId : modalId"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [alertType]="alertType"
  (onCloseAlert)="alertShow = false"
  (onCommitSave)="commitSave($event)"
>
  <form #numberSchemaForm="ngForm">
    <accordion>
      <accordion-group
        #accordion1
        [isOpen]="true"
        (isOpenChange)="accordion1.isOpen = $event"
      >
        <div accordion-heading class="clearfix">
          {{ "general_information" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i
              class="fa"
              [ngClass]="accordion1.isOpen ? 'fa-minus' : 'fa-plus'"
            ></i
          ></span>
        </div>
        <section class="part">
          <div class="col-md-12 col-sm-12 row">
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="number_scheme_code" class="col-md-3">
                  <small>
                    {{ "code" | translate }} <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-9 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    #numberSchemeCode="ngModel"
                    [disabled]="isReadOnly"
                    name="number_scheme_code"
                    id="number_scheme_code"
                    [(ngModel)]="entity.code"
                    (ngModelChange)="formChange(true)"
                    [ngClass]="{
                      errorInput: alertShow && numberSchemeCode.invalid
                    }"
                    maxlength="10"
                    autofocus
                    required
                  />
                  <div
                    *ngIf="alertShow && numberSchemeCode.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="number_scheme_description" class="col-md-3">
                  <small>
                    {{ "description" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-9 col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    #numberSchemeDescription="ngModel"
                    [disabled]="isReadOnly"
                    name="number_scheme_description"
                    id="number_scheme_description"
                    [(ngModel)]="entity.description"
                    (ngModelChange)="formChange(true)"
                    [ngClass]="{
                      errorInput: alertShow && numberSchemeDescription.invalid
                    }"
                    maxlength="50"
                    required
                  />
                  <div
                    *ngIf="alertShow && numberSchemeDescription.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="number_scheme_document_type" class="col-md-3">
                  <small>
                    {{ "document_type" | translate }}
                    <i class="text-danger">*</i></small
                  >
                </label>
                <div class="col-md-9 col-sm-12">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    [options]="documentTypeOptions"
                    name="number_scheme_document_type"
                    id="number_scheme_document_type"
                    [style]="{ width: '100%' }"
                    [(ngModel)]="entity.document_type"
                    (onChange)="formChange(true)"
                    #numberSchemaDocumentType="ngModel"
                    [filter]="true"
                    [ngClass]="{
                      errorInput: alertShow && numberSchemaDocumentType.invalid
                    }"
                    required
                  ></p-dropdown>
                  <div
                    *ngIf="alertShow && numberSchemaDocumentType.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="number_scheme_last_num" class="col-md-3">
                  <small>{{ "last_num" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-12">
                  <input
                    [disabled]="isReadOnly"
                    type="text"
                    maxlength="20"
                    id="number_scheme_last_num"
                    name="number_scheme_last_num"
                    [(ngModel)]="entity.last_num"
                    (ngModelChange)="formChange(true)"
                    #numberSchemaLastNo="ngModel"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="number_scheme_status" class="col-md-3 col-sm-12">
                  <small>{{ "status" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-12">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    [disabled]="isReadOnly"
                    id="number_scheme_status"
                    #numberSchemeStatus="ngModel"
                    [(ngModel)]="entity.status"
                    (onChange)="formChange(true)"
                    [options]="[
                      { label: 'ACTIVE' | translate, value: 'ACTIVE' },
                      { label: 'PASSIVE' | translate, value: 'PASSIVE' }
                    ]"
                    [style]="{ width: '100%' }"
                    name="number_scheme_status"
                  >
                  </p-dropdown>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="number_scheme_begin_date"
                  class="col-md-3 col-sm-12"
                >
                  <small>{{ "begin_date" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-12">
                  <p-calendar
                    [disabled]="isReadOnly"
                    [(ngModel)]="entity.begin_date"
                    (ngModelChange)="formChange(true)"
                    #numberSchemaBeginDate="ngModel"
                    name="number_scheme_begin_date"
                    id="number_scheme_begin_date"
                    [locale]="locale"
                    [dateFormat]="dateFormatString"
                    (onSelect)="endDateMin = $event"
                    [styleClass]="
                      (numberSchemaBeginDate.invalid && alertShow) || dateError
                        ? 'is-invalid dateInput'
                        : 'dateInput'
                    "
                    [showIcon]="true"
                    required
                  >
                  </p-calendar>
                  <div
                    *ngIf="alertShow && numberSchemaBeginDate.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="number_scheme_end_date" class="col-md-3 col-sm-12">
                  <small>{{ "end_date" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-12">
                  <p-calendar
                    [disabled]="isReadOnly"
                    [(ngModel)]="entity.end_date"
                    (ngModelChange)="formChange(true)"
                    #numberSchemaEndDate="ngModel"
                    [minDate]="endDateMin"
                    name="number_scheme_end_date"
                    id="number_scheme_end_date"
                    [locale]="locale"
                    [dateFormat]="dateFormatString"
                    [styleClass]="
                      (numberSchemaEndDate.invalid && alertShow) || dateError
                        ? 'is-invalid dateInput'
                        : 'dateInput'
                    "
                    [showIcon]="true"
                    [required]="true"
                  >
                  </p-calendar>
                  <div
                    *ngIf="alertShow && numberSchemaEndDate.invalid"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                  <div *ngIf="dateError" class="errorMessage">
                    Bitiş tarihi başlangıç tarihinden küçük olamaz
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="part">
          <div class="col-md-12 col-sm-12 row">
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="number_scheme_user_role" class="col-md-3">
                  <small>{{ "user_role" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-12">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    id="number_scheme_user_role"
                    dataKey="id"
                    [options]="numberSchemeUserRoleArray"
                    [placeholder]="'unselected' | translate"
                    optionLabel="description"
                    inputId="number_scheme_user_role"
                    [disabled]="isReadOnly"
                    [(ngModel)]="entity.user_role"
                    (onChange)="formChange(true)"
                    name="number_scheme_user_role"
                    [style]="{ width: '100%' }"
                  >
                  </p-dropdown>
                  <a
                    class="dropdownInput inputClear"
                    [hidden]="!entity.user_role || isReadOnly"
                    (click)="entity.user_role = null"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="form-group row">
                <label for="number_scheme_user" class="col-md-3">
                  <small>{{ "user" | translate }}</small>
                </label>
                <div class="col-md-9 col-sm-12">
                  <p-dropdown
                    [emptyFilterMessage]="'not_found' | translate"
                    id="number_scheme_user"
                    [options]="numberSchemeUserArray"
                    [placeholder]="'unselected' | translate"
                    dataKey="id"
                    optionLabel="full_name"
                    inputId="number_scheme_user"
                    [disabled]="isReadOnly"
                    [(ngModel)]="entity.user"
                    name="number_scheme_user"
                    [style]="{ width: '100%' }"
                  >
                  </p-dropdown>
                  <a
                    class="dropdownInput inputClear"
                    [hidden]="!entity.user || isReadOnly"
                    (click)="entity.user = null"
                  >
                    <i class="fal fa-close"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </accordion-group>
      <accordion-group
        [isOpen]="isOpenLine"
        (isOpenChange)="openLineAccordion($event)"
      >
        <div accordion-heading class="clearfix">
          {{ "number_scheme_detail" | translate }}
          <span class="badge badge-secondary float-right pull-right">
            <i class="fa" [ngClass]="isOpenLine ? 'fa-minus' : 'fa-plus'"></i
          ></span>
        </div>
        <section class="part">
          <div class="col-md-12 col-sm-12">
            <button
              class="btn btn-default mb-1 btn-sm"
              [hidden]="isReadOnly || schemeCurrentLength > 19"
              (click)="addNewRow()"
            >
              {{ "add_new_line" | translate }}
            </button>
            <kl-form-entry-grid
              *ngIf="showLineGrid"
              (onColumnChange)="enableCustomValidation($event)"
              (onLostFocus)="enableCustomValidation($event)"
              (onAddNew)="addNewRow()"
              (onDelete)="calculateSchemeLength($event)"
              (onCellEdit)="cellEdit($event)"
              [actionButton]="isReadOnly"
              [collectionView]="numberSchemeCollectionView"
              [showErrors]="showValidationErrors"
              [validateEdits]="validateEdits"
              [isReadOnly]="isReadOnly"
              [columns]="[
                {
                  header: 'type' | translate,
                  binding: 'type',
                  width: '*',
                  dataMap: numberSchemeTypeDataMap,
                  showDropDown: true
                },
                {
                  header: 'length' | translate,
                  binding: 'length',
                  width: '*',
                  dataType: 'Number',
                  maxLength: 2
                },
                { header: 'value' | translate, binding: 'value', width: '*' }
              ]"
            ></kl-form-entry-grid>
          </div>
        </section>
      </accordion-group>
    </accordion>
  </form>
</kl-form-container>
